<template>
  <div>
    <div class="modal fade" data-backdrop="static" id="modal-create-liabilities">
      <div class="modal-dialog" style="width:700px !important;">
        <div class="modal-content">
          <div class="modal-header">
            <h3
              class="modal-title"
              style="text-align:left;"
            >{{$t('invoice.modal_create_liabilities.title')}}</h3>
          </div>
          <div class="modal-body">
            <b-form>
              <div class="row mb-1 margin-down-15">
                <div class="form-group">
                  <label
                    for="name"
                    class="col-md-3 col-sm-3 control-label"
                    style="margin-top:13px;"
                  >{{$t('invoice.modal_create_liabilities.label_create_type')}}</label>
                  <div class="col-md-6 col-sm-6">
                    <div class="radio">
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios1"
                          value="1"
                          v-model="picked"
                          checked
                        />
                        {{$t('invoice.modal_create_liabilities.label_by_month')}}
                      </label>
                      <label style="margin-left:30px;"></label>
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="2"
                          v-model="picked"
                        />
                        {{$t('invoice.modal_create_liabilities.label_by_selected')}}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-1 margin-down-15" v-if="picked == 1 ? true: false">
                <div class="form-group">
                  <label for="name" class="col-md-3 col-sm-3 control-label">{{$t('invoice.month')}}</label>

                  <div class="col-md-6 col-sm-6">
                    <b-form-select
                      class="form-control select2"
                      style="width: 100%;"
                      tabindex="-1"
                      v-model="periodSelected"
                      :options="periods"
                    />
                  </div>

                  <!-- /.input group -->
                </div>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm pull-right mg-left"
              @click="onCheckLiabilities"
            >{{$t('common.move')}}</button>
            <button
              type="button"
              class="btn btn-warning btn-sm pull-left"
              @click="closeModal"
            >{{$t('common.back')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal fade" data-backdrop="static" id="modal-confirm-create-liabilities">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h3 class="modal-title">{{$t('invoice.modal_create_liabilities_confirm.title')}}</h3>
          </div>
          <div class="modal-body">
            <div class="row" v-if="picked == 2">
              <div v-if="invoiceNotExportLiabilitList.length != 0" class="col-sm-12">
                <span
                  style="color: red; font-weight: bold"
                >* Danh sách phiếu báo dưới đây đã được chuyển vô công nợ nên không thể chuyển nữa</span>
                <b-table
                  style="white-space: nowrap; max-height: 200px; overflow-y:auto;"
                  responsive
                  :items="invoiceNotExportLiabilitList"
                  :fields="invoiceLiabilitFields"
                  class="mt-3"
                  outlined
                >
                  <!-- <template
                    v-for="index in invoiceLiabilitFields"
                    :slot="'HEAD_' + index.key"
                    slot-scope="item"
                  >{{ $t(item.label) }}</template> -->
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                </b-table>
              </div>
              <div class="col-sm-12">
                <span
                  style="margin: 10px 0 10px 0; font-weight: bold"
                >Danh sách phiếu báo có thể chuyển vô công nợ</span>
                <b-table
                  style="white-space: nowrap; max-height: 200px; overflow-y:auto;"
                  responsive
                  :items="invoiceExportLiabilitList"
                  :fields="invoiceLiabilitFields"
                  class="mt-3"
                  outlined
                >
                  <template #head()="scope">
                    <div>{{ $t(scope.label) }}</div>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="row" v-if="picked == 1">
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    for="name"
                    class="col-md-7 col-sm-7 control-label"
                  >{{$t('invoice.modal_create_liabilities_confirm.confirm_by_month')}}</label>
                  <div class="col-md-5 col-sm-5">
                    <b-form-select
                      disabled
                      class="form-control select2"
                      style="width: 100%;"
                      tabindex="-1"
                      v-model="periodSelected"
                      :options="periods"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              @click="closeModalConfirm"
            >{{$t('common.back')}}</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onCreateLiabilitiesConfirm"
            >{{$t('common.confirm')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from 'moment'
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
// import utils from '@/lib/utils'

export default {
  name: "ModalCreateLiabilities",
  data() {
    return {
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      isLoading: false,
      // Month
      periods: [],
      // Month select
      periodSelected: null,
      // type select for delete
      picked: 1, // 1: month / 2: selected
      user_id: null,
      list_invoice_id: [],
      invoiceInformationList: [],
      invoiceNotExportLiabilitList: [],
      invoiceExportLiabilitList: [],
      invoiceLiabilitFields: [
        { key: "no", label: "#", sortable: true, class: "text-center" },
        {
          key: "invoice_number",
          label: "Số Phiếu Báo",
          sortable: true,
          class: "text-center"
        },
        {
          key: "apartment_code",
          label: "Mã Căn Hộ",
          sortable: true,
          class: "text-center"
        },
        {
          key: "owner_resident",
          label: "Thông Tin Chủ Hộ",
          sortable: true,
          class: "text-center"
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    onSaveLiability: function() {
      let data = {
        pick_type: parseInt(this.picked),
        invoice_list_id: this.list_invoice_id,
        user_created: this.user_id
      };
      $("#modal-confirm-create-liabilities").modal("hide");
      this.isLoading = true;
      // init empty
      this.CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE(data).then(
        function(res) {
          this.ON_SHOW_TOAST({
            message: this.$t("invoice.liability.success"),
            styleType: "success"
          });
          this.isLoading = false;
        }.bind(this)
      )
      .catch(
        function(error) {
          this.ON_SHOW_TOAST({
            message: error,
            styleType: "danger"
          });
          this.isLoading = false;
        }.bind(this)
      );
    },
    submit(
      user_id,
      invoiceInformationList,
      periods,
      invoiceLiabilitFields,
      invoiceExportLiabilitList,
      invoiceNotExportLiabilitList,
      list_invoice_id
    ) {
      var today = new Date()
      var date = (today.getMonth()+1)+'-'+today.getFullYear();
      for (let index = 0; index < periods.length; index++) {
        const element = periods[index];
        const date_from = parseInt(element.date_from.split("-")[1]) + "-" + element.date_from.split("-")[0]
        if (date_from == date)
        {
          this.periodSelected = index + 1
        }
      }
      this.user_id = user_id;
      this.invoiceInformationList = invoiceInformationList;
      this.periods = periods;
      this.list_invoice_id = list_invoice_id;
      this.invoiceLiabilitFields = invoiceLiabilitFields;
      this.invoiceExportLiabilitList = invoiceExportLiabilitList;
      this.invoiceNotExportLiabilitList = invoiceNotExportLiabilitList;
      $("#modal-create-liabilities").modal("show");
    },

    /*
     * author : [loitt]
     * function: close Modal
     */
    closeModal: function() {
      $("#modal-create-liabilities").modal("hide");
    },
    closeModalConfirm: function() {
      $("#modal-confirm-create-liabilities").modal("hide");
      $("#modal-create-liabilities").modal("show");
    },
    onCheckLiabilities: function() {
      $("#modal-create-liabilities").modal("hide");

      if (this.picked == 2) {
        let isAvailableLiabilit = false;
        if (this.invoiceInformationList.length <= 0) {
          this.ON_SHOW_TOAST({
            message: this.$t("invoice.liability.error_not_select_invoice"),
            styleType: "danger"
          });
          return;
        } else {
          this.invoiceExportLiabilitList = [];
          this.invoiceNotExportLiabilitList = [];
          let noOfInvoiceExportLiabilit = 0;
          let noOfInvoiceNotExportLiabilit = 0;
          for (
            let i = 0, size = this.invoiceInformationList.length;
            i < size;
            i++
          ) {
            if (
              this.invoiceInformationList[i].exported_to_liability == "false"
            ) {
              isAvailableLiabilit = true;
              let object = {
                no: (noOfInvoiceExportLiabilit += 1),
                invoice_number: this.invoiceInformationList[i].invoice_number,
                apartment_code: this.invoiceInformationList[i].apartment_code,
                owner_resident: this.invoiceInformationList[i][
                  "invoice.owner_apartment"
                ]
              };
              this.invoiceExportLiabilitList.push(object);
            } else {
              let object = {
                no: (noOfInvoiceNotExportLiabilit += 1),
                invoice_number: this.invoiceInformationList[i].invoice_number,
                apartment_code: this.invoiceInformationList[i].apartment_code,
                owner_resident: this.invoiceInformationList[i][
                  "invoice.owner_apartment"
                ]
              };
              this.invoiceNotExportLiabilitList.push(object);
            }
          }
        }
        if (isAvailableLiabilit) {
          $("#modal-confirm-create-liabilities").modal("show");
        } else {
          this.ON_SHOW_TOAST({
            message: "Tất Cả Phiếu Báo Được Chọn Đã Chuyển Vô Công Nợ",
            styleType: "danger"
          });
        }
      } else {
        // Hàm này chuyển theo tháng
        $("#modal-confirm-create-liabilities").modal("show");
      }
    },

    onCreateLiabilitiesConfirm: function() {
      this.onSaveLiability();
      this.picked = 1;
      this.list_invoice_id = [];
      this.invoiceInformationList = [];
      this.invoiceNotExportLiabilitList = [];
      this.invoiceExportLiabilitList = [];
      this.$emit("callBackActionCreateLiabilities");
    },

    ...mapActions([
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "CREATE_ACCOUNTING_HOME_LIABILITY_FROM_INVOICE",
    ])
  },
  mounted() {},
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  }
};
</script>
<style lang="scss" scoped>
.mg-left {
  margin-left: 5px;
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/ModalCreateLiabilities.vue